/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { GbGeschaeftId } from '../model/models';
import { GrundbuchgeschaeftListEntryMeta } from '../model/models';
import { GrundbuchgeschaeftRestDetailEntryMeta } from '../model/models';
import { GrundbuchgeschaeftSearchRequestEgbtbid } from '../model/models';
import { GrundbuchgeschaeftSearchRequestEgbtbidMeta } from '../model/models';
import { GrundbuchgeschaeftSearchRequestStandard } from '../model/models';
import { GrundbuchgeschaeftSearchRequestStandardMeta } from '../model/models';
import { GrundbuchgeschaeftSearchResponseMeta } from '../model/models';
import { GrundbuchmeldungBearbeitetstatusResponseMeta } from '../model/models';
import { LoadGbGeschaeftSichtByGrundstueckIdsRequest } from '../model/models';
import { LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class GbgrundbuchgeschaeftService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param geschaeftId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGbGeschaeftBearbeitetstatus(geschaeftId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchmeldungBearbeitetstatusResponseMeta>;
    public getGbGeschaeftBearbeitetstatus(geschaeftId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchmeldungBearbeitetstatusResponseMeta>>;
    public getGbGeschaeftBearbeitetstatus(geschaeftId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchmeldungBearbeitetstatusResponseMeta>>;
    public getGbGeschaeftBearbeitetstatus(geschaeftId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (geschaeftId === null || geschaeftId === undefined) {
            throw new Error('Required parameter geschaeftId was null or undefined when calling getGbGeschaeftBearbeitetstatus.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchmeldungBearbeitetstatusResponseMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/${encodeURIComponent(String(geschaeftId))}/bearbeitungsstatus`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param egbtbid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGbGeschaeftByEgbtbid(egbtbid: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchgeschaeftRestDetailEntryMeta>;
    public loadGbGeschaeftByEgbtbid(egbtbid: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchgeschaeftRestDetailEntryMeta>>;
    public loadGbGeschaeftByEgbtbid(egbtbid: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchgeschaeftRestDetailEntryMeta>>;
    public loadGbGeschaeftByEgbtbid(egbtbid: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (egbtbid === null || egbtbid === undefined) {
            throw new Error('Required parameter egbtbid was null or undefined when calling loadGbGeschaeftByEgbtbid.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (egbtbid !== undefined && egbtbid !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>egbtbid, 'egbtbid');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchgeschaeftRestDetailEntryMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGbGeschaeftById(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchgeschaeftRestDetailEntryMeta>;
    public loadGbGeschaeftById(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchgeschaeftRestDetailEntryMeta>>;
    public loadGbGeschaeftById(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchgeschaeftRestDetailEntryMeta>>;
    public loadGbGeschaeftById(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling loadGbGeschaeftById.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchgeschaeftRestDetailEntryMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param amtNummer 
     * @param jahr 
     * @param nummer 
     * @param index 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGbGeschaeftId(amtNummer?: number, jahr?: number, nummer?: number, index?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GbGeschaeftId>;
    public loadGbGeschaeftId(amtNummer?: number, jahr?: number, nummer?: number, index?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GbGeschaeftId>>;
    public loadGbGeschaeftId(amtNummer?: number, jahr?: number, nummer?: number, index?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GbGeschaeftId>>;
    public loadGbGeschaeftId(amtNummer?: number, jahr?: number, nummer?: number, index?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (amtNummer !== undefined && amtNummer !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>amtNummer, 'amtNummer');
        }
        if (jahr !== undefined && jahr !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>jahr, 'jahr');
        }
        if (nummer !== undefined && nummer !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummer, 'nummer');
        }
        if (index !== undefined && index !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>index, 'index');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GbGeschaeftId>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/id`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGbGeschaeftListEntryById(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchgeschaeftListEntryMeta>;
    public loadGbGeschaeftListEntryById(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchgeschaeftListEntryMeta>>;
    public loadGbGeschaeftListEntryById(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchgeschaeftListEntryMeta>>;
    public loadGbGeschaeftListEntryById(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling loadGbGeschaeftListEntryById.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchgeschaeftListEntryMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/list/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundstueckIds 
     * @param off 
     * @param lim 
     * @param sdir 
     * @param sort 
     * @param auftragLoadOption 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGbGeschaeftSichtGrundstueck(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'TAGEBUCHNUMMER' | 'STATUS' | 'EINGANG_TAGEBUCH', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>;
    public loadGbGeschaeftSichtGrundstueck(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'TAGEBUCHNUMMER' | 'STATUS' | 'EINGANG_TAGEBUCH', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>>;
    public loadGbGeschaeftSichtGrundstueck(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'TAGEBUCHNUMMER' | 'STATUS' | 'EINGANG_TAGEBUCH', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>>;
    public loadGbGeschaeftSichtGrundstueck(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'TAGEBUCHNUMMER' | 'STATUS' | 'EINGANG_TAGEBUCH', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (grundstueckIds === null || grundstueckIds === undefined) {
            throw new Error('Required parameter grundstueckIds was null or undefined when calling loadGbGeschaeftSichtGrundstueck.');
        }
        if (off === null || off === undefined) {
            throw new Error('Required parameter off was null or undefined when calling loadGbGeschaeftSichtGrundstueck.');
        }
        if (lim === null || lim === undefined) {
            throw new Error('Required parameter lim was null or undefined when calling loadGbGeschaeftSichtGrundstueck.');
        }
        if (sdir === null || sdir === undefined) {
            throw new Error('Required parameter sdir was null or undefined when calling loadGbGeschaeftSichtGrundstueck.');
        }
        if (sort === null || sort === undefined) {
            throw new Error('Required parameter sort was null or undefined when calling loadGbGeschaeftSichtGrundstueck.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckIds !== undefined && grundstueckIds !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>grundstueckIds, 'grundstueckIds');
        }
        if (auftragLoadOption !== undefined && auftragLoadOption !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>auftragLoadOption, 'auftragLoadOption');
        }
        if (off !== undefined && off !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>off, 'off');
        }
        if (lim !== undefined && lim !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>lim, 'lim');
        }
        if (sdir !== undefined && sdir !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sdir, 'sdir');
        }
        if (sort !== undefined && sort !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sort, 'sort');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/sicht/Grundstueck`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param loadGbGeschaeftSichtByGrundstueckIdsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGbGeschaeftSichtGrundstuecke(loadGbGeschaeftSichtByGrundstueckIdsRequest: LoadGbGeschaeftSichtByGrundstueckIdsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>;
    public loadGbGeschaeftSichtGrundstuecke(loadGbGeschaeftSichtByGrundstueckIdsRequest: LoadGbGeschaeftSichtByGrundstueckIdsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>>;
    public loadGbGeschaeftSichtGrundstuecke(loadGbGeschaeftSichtByGrundstueckIdsRequest: LoadGbGeschaeftSichtByGrundstueckIdsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>>;
    public loadGbGeschaeftSichtGrundstuecke(loadGbGeschaeftSichtByGrundstueckIdsRequest: LoadGbGeschaeftSichtByGrundstueckIdsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (loadGbGeschaeftSichtByGrundstueckIdsRequest === null || loadGbGeschaeftSichtByGrundstueckIdsRequest === undefined) {
            throw new Error('Required parameter loadGbGeschaeftSichtByGrundstueckIdsRequest was null or undefined when calling loadGbGeschaeftSichtGrundstuecke.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<LoadGbGeschaeftSichtByGrundstueckIdsResponseMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/sicht/Grundstueck`,
            loadGbGeschaeftSichtByGrundstueckIdsRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundbuchgeschaeftSearchRequestEgbtbid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGbGeschaeftEgbtbid(grundbuchgeschaeftSearchRequestEgbtbid: GrundbuchgeschaeftSearchRequestEgbtbid, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchgeschaeftSearchResponseMeta>;
    public searchGbGeschaeftEgbtbid(grundbuchgeschaeftSearchRequestEgbtbid: GrundbuchgeschaeftSearchRequestEgbtbid, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchgeschaeftSearchResponseMeta>>;
    public searchGbGeschaeftEgbtbid(grundbuchgeschaeftSearchRequestEgbtbid: GrundbuchgeschaeftSearchRequestEgbtbid, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchgeschaeftSearchResponseMeta>>;
    public searchGbGeschaeftEgbtbid(grundbuchgeschaeftSearchRequestEgbtbid: GrundbuchgeschaeftSearchRequestEgbtbid, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (grundbuchgeschaeftSearchRequestEgbtbid === null || grundbuchgeschaeftSearchRequestEgbtbid === undefined) {
            throw new Error('Required parameter grundbuchgeschaeftSearchRequestEgbtbid was null or undefined when calling searchGbGeschaeftEgbtbid.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<GrundbuchgeschaeftSearchResponseMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/searchEgbtbid`,
            grundbuchgeschaeftSearchRequestEgbtbid,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGbGeschaeftEgbtbidTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchgeschaeftSearchRequestEgbtbidMeta>;
    public searchGbGeschaeftEgbtbidTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchgeschaeftSearchRequestEgbtbidMeta>>;
    public searchGbGeschaeftEgbtbidTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchgeschaeftSearchRequestEgbtbidMeta>>;
    public searchGbGeschaeftEgbtbidTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchgeschaeftSearchRequestEgbtbidMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/searchEgbtbid`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundbuchgeschaeftSearchRequestStandard 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGbGeschaeftStandard(grundbuchgeschaeftSearchRequestStandard: GrundbuchgeschaeftSearchRequestStandard, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchgeschaeftSearchResponseMeta>;
    public searchGbGeschaeftStandard(grundbuchgeschaeftSearchRequestStandard: GrundbuchgeschaeftSearchRequestStandard, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchgeschaeftSearchResponseMeta>>;
    public searchGbGeschaeftStandard(grundbuchgeschaeftSearchRequestStandard: GrundbuchgeschaeftSearchRequestStandard, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchgeschaeftSearchResponseMeta>>;
    public searchGbGeschaeftStandard(grundbuchgeschaeftSearchRequestStandard: GrundbuchgeschaeftSearchRequestStandard, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (grundbuchgeschaeftSearchRequestStandard === null || grundbuchgeschaeftSearchRequestStandard === undefined) {
            throw new Error('Required parameter grundbuchgeschaeftSearchRequestStandard was null or undefined when calling searchGbGeschaeftStandard.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<GrundbuchgeschaeftSearchResponseMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/searchStandard`,
            grundbuchgeschaeftSearchRequestStandard,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGbGeschaeftStandardTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchgeschaeftSearchRequestStandardMeta>;
    public searchGbGeschaeftStandardTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchgeschaeftSearchRequestStandardMeta>>;
    public searchGbGeschaeftStandardTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchgeschaeftSearchRequestStandardMeta>>;
    public searchGbGeschaeftStandardTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchgeschaeftSearchRequestStandardMeta>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/searchStandard`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param geschaeftId 
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setGbGeschaeftBearbeitetstatus(geschaeftId: string, status: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public setGbGeschaeftBearbeitetstatus(geschaeftId: string, status: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public setGbGeschaeftBearbeitetstatus(geschaeftId: string, status: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public setGbGeschaeftBearbeitetstatus(geschaeftId: string, status: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (geschaeftId === null || geschaeftId === undefined) {
            throw new Error('Required parameter geschaeftId was null or undefined when calling setGbGeschaeftBearbeitetstatus.');
        }
        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling setGbGeschaeftBearbeitetstatus.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/gb/grundbuchgeschaeft/${encodeURIComponent(String(geschaeftId))}/bearbeitungsstatus`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
